module.exports = __webpack_public_path__ + "media/images/flags/SM-ae707145c12c6cf59d6b50fbf08d1165.svg";